import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class Collage extends React.Component
{
    static propTypes = {
        photos: PropTypes.array.isRequired,
        width: PropTypes.string,
        height: PropTypes.array,
        layout: PropTypes.array,
        showNumOfRemainingPhotos: PropTypes.bool
    };

    static defaultProps = {
        width: '600px',
        height: ['250px', '170px'],
        layout: [1, 4],
        showNumOfRemainingPhotos: true
    }

    render()
    {
        const { width, height, layout, photos, showNumOfRemainingPhotos } = this.props;

        if (photos.length < 1) {
            return null;
        }

        const layoutPhotoMaps = this.createLayoutPhotoMaps(layout, photos);
        const layoutNum = layout.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
        const remainingNum = photos.length - layoutNum;

        return <div className='font-sans' style={{width: width}}>
            {
                layout.map((data, i) => {

                    return (
                        <RowPhotos
                            key={i}
                            height={height[i]}
                            photos={layoutPhotoMaps[i]}
                            layoutNum={layoutNum}
                            remainingNum={remainingNum}
                            showNumOfRemainingPhotos={showNumOfRemainingPhotos}
                        />
                    )
                })
            }
        </div>
    }

    createPhotoIds = (photos) => {
        return photos.map((data, i) => ({ ...data, id: i }));
    }

    createLayoutPhotoMaps = (layout, photos) => {
        const newPhotos = this.createPhotoIds(photos);
        const newMaps = {};

        layout.reduce((accumulator, currentValue, currentIndex) => {
            newMaps[currentIndex] = newPhotos.slice(accumulator, accumulator + currentValue);
            return accumulator + currentValue;
        }, 0);
    
        return newMaps;
    }
}

class RowPhotos extends React.Component
{
    render()
    {
        const { height, photos, layoutNum, remainingNum, showNumOfRemainingPhotos } = this.props;

        if (photos.length === 0) {
            return null;
        }

        return <div className='flex' style={{height: height}}>
            {
                photos.map((data, i) =>
                    <div className='flex relative flex-1' key={i} data-id={data.id}>
                        {
                            showNumOfRemainingPhotos && remainingNum > 0 && data.id === (layoutNum - 1) ?
                            (
                                <>
                                    <div className='block bg-black opacity-50 w-full h-full z-10 absolute pointer' />
                                    <div className='w-full h-full absolute z-10 pointer'>
                                        <div className='absolute text-white text-4xl' style={{left: '50%', top: '50%', transform: 'translate(-50%, -50%)'}}>&#43;{remainingNum}</div>
                                    </div>
                                </>
                            ) : null
                        }
                        <div className='flex-1 bg-center bg-cover bg-no-repeat' style={{backgroundImage: `url('${data.src}')`}} />
                    </div>
                )
            }
        </div>;
    }
}
